import PricingPlan from "./PricingPlan";
import { monthlyPlan, yearlyPlan } from "../../constants/Subscription";
import { useEffect, useState } from "react";
import { Plan } from "../../@types/subscripton";

interface SubscriptionBoxProps {
  isChoosing: boolean;
  indexState: number | null;
}

const SubscriptionBox = ({ isChoosing, indexState }: SubscriptionBoxProps) => {
  const [month, setMonth] = useState(true);
  const [year, setYear] = useState(false);
  const [plans, setPlans] = useState<Plan[]>([]);
  const handleMonthly = () => {
    setMonth(true);
    setYear(false);
    setPlans([...monthlyPlan]);
  };
  const handleYearly = () => {
    setMonth(false);
    setYear(true);
    setPlans([...yearlyPlan]);
  };
  useEffect(() => {
    handleMonthly();
  }, []);
  return (
    <>
      <div className="w-full relative z-50 s">
        <div className="flex flex-col items-center justify-center lg:mb-[64px]">
          <div className="flex items-center bg-[#F2F4F7] rounded-lg p-1 w-fit">
            <button
              onClick={handleMonthly}
              className={`${
                month && !year
                  ? "bg-white shadow text-[#1D2939]"
                  : "bg-transparent text-[#6B7280]"
              } font-semibold text-[16px] px-5 py-2 rounded-lg transition-all`}
            >
              MONTHLY
            </button>
            <button
              onClick={handleYearly}
              className={`flex items-center gap-2 font-semibold text-[16px] px-5 py-2 rounded-lg transition-all ${
                year && !month
                  ? "bg-white shadow text-[#1D2939]"
                  : "bg-transparent text-[#6B7280]"
              }`}
            >
              YEARLY
            </button>
          </div>
          <p className="text-[#344054] pt-2 font-medium text-sm text-center">
            Save 20% on annual billings
          </p>
        </div>
        <div className="flex flex-col gap-4 md:gap-0 md:flex-row md:justify-center md:items-center w-full mt-[1em] pb-10">
          {plans.map((plan, index) => (
            <PricingPlan
              key={index}
              discount={plan.discount}
              title={plan.title}
              price={plan.price}
              features={plan.features}
              buttonText={plan.buttonText}
              plan={plan.plan}
              index={index}
              duration={plan.duration}
              subPrice={plan.subPrice}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default SubscriptionBox;
